const registerAddress = ADDRESS => ({ ADDRESS });
const registerPort = PORT => ({ PORT });
const registerName = NAME => ({ NAME });

module.exports = ({ CONSUL_ADDRESS, CONSUL_PORT, CONSUL_NAME }) => ({
  ...registerAddress(CONSUL_ADDRESS),
  ...registerPort(Number(CONSUL_PORT)),
  ...registerName(CONSUL_NAME)
});
